import { selectCurrentHotelId } from 'accessors'
import { gotNotificationPreferences } from 'actions/notifications'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import notificationsApi from 'services/api/notifications'

import styles from './EnableNotificationPrefenceBox.module.scss'
import notificationIcon from './notification.png'

const EnableNotificationPrefenceBox = () => {
  const notificationPreferences = useSelector(
    s => s.notifications.notificationPreferences
  )

  const [isSaving, setIsSaving] = useState()

  const dispatch = useDispatch()

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  async function turnOnNotifications() {
    setIsSaving(true)

    let data = notificationPreferences

    const negativeReviewIndex = data.findIndex(n => n.kind === 'NegativeReview')

    data[negativeReviewIndex].subsidiaries = [
      ...data[negativeReviewIndex].subsidiaries,
      currentSubsidiaryId
    ]

    const newMessageIndex = data.findIndex(n => n.kind === 'WaitingClientChatExists')

    data[newMessageIndex].subsidiaries = [
      ...data[newMessageIndex].subsidiaries,
      currentSubsidiaryId
    ]

    notificationsApi
      .putPreferences({
        items: data
      })
      .then(res => {
        dispatch(gotNotificationPreferences(res))
      })
  }

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img src={notificationIcon} alt="notification icon" width={130} />
      </div>
      <div className={styles.textContainer}>
        <h1>Allow notifications to use messaging</h1>
        <button
          className={styles.primaryButton}
          disabled={isSaving}
          onClick={turnOnNotifications}
        >
          Turn on notifications for this hotel
        </button>
        <Link to="/notificationPreferences">
          <button className={styles.secondaryButton}>Configure all notifications</button>
        </Link>
      </div>
    </div>
  )
}

export default EnableNotificationPrefenceBox
